<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 82 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M14.955 64.52c0-.452-.159-.801-.475-1.047-.317-.247-.75-.37-1.301-.37H10.72v2.853h2.458c.537 0 .967-.126 1.29-.38.324-.253.486-.605.486-1.057M28.038 65.576c.323-.253.485-.605.485-1.057 0-.451-.159-.8-.475-1.046-.317-.247-.75-.37-1.301-.37h-2.458v2.853h2.458c.537 0 .967-.126 1.29-.38"
      />
      <path
        d="M47.048 59.983h4.337l2.56 3.695 2.582-3.695h4.275l-4.709 6.63 5.535 7.738H57.27l-3.386-4.782-3.367 4.782h-4.295l5.534-7.717-4.708-6.65zm-13.713 3.243v-3.243h12.412v3.243h-4.358v11.125h-3.717V63.226h-4.337zM20.572 74.351V59.983h6.443c1.625 0 2.905.418 3.842 1.252.95.835 1.425 1.916 1.425 3.243 0 1.328-.475 2.416-1.425 3.264-.937.835-2.217 1.252-3.842 1.252H24.29v5.357h-3.717zm50.635 19.13H16.07c-2.287 0-4.148-1.85-4.148-4.124v-4.77h51.401c2.383 0 4.315-1.918 4.315-4.288V54.29c0-2.37-1.932-4.29-4.315-4.29H11.922V10.644c0-2.269 1.861-4.119 4.148-4.119l37.957-.04V20.43c0 4.073 3.325 7.38 7.426 7.38l13.744-.039.154 61.586c0 2.275-1.857 4.125-4.144 4.125zm-60.486-19.13H7.004V59.983h6.443c1.625 0 2.905.418 3.841 1.252.95.835 1.425 1.916 1.425 3.243 0 1.328-.475 2.416-1.425 3.264-.936.835-2.216 1.252-3.841 1.252h-2.726v5.357zM56.481.001H16.07C10.166 0 5.36 4.778 5.36 10.642V50H4.316C1.932 50 0 51.92 0 54.289v26.01c0 2.37 1.932 4.288 4.315 4.288h1.046v4.77C5.36 95.227 10.166 100 16.07 100h55.137c5.901 0 10.707-4.773 10.707-10.643V25.19L56.48 0z"
      />
      <path
        d="M34.696 18.096h-1.423c-6.486 0-11.748 5.23-11.748 11.676s5.262 11.676 11.748 11.676c6.485 0 11.747-5.23 11.747-11.676v-1.414H34.696V18.096z"
      />
      <path d="M47.9 25.101c-.729-5.065-4.8-9.143-9.928-9.866l-1.622-.23v11.708h11.78l-.23-1.612z" />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-pptx',
    props: {
      width: {
        type: [Number, String],
        default: 82
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
